// src/main.js (Simplified without Pinia)
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

// Bootstrap JS
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap   // <-- ADD THIS LINE


// Custom styles
import './assets/styles/main.scss'

// Perfect Scrollbar
import 'perfect-scrollbar/css/perfect-scrollbar.css'

// Services
import AuthenticationService from './services/authentication/AuthenticationService'
import ApiService from './services/api'
import UserService from './services/users/UserService'
import CommonService from './services/CommonService'

function installSpaLinkNavigation() {
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented) {
      return
    }

    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return
    }

    const anchor = event.target.closest('a[href]')
    if (!anchor) {
      return
    }

    const href = (anchor.getAttribute('href') || '').trim()
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) {
      return
    }

    const target = (anchor.getAttribute('target') || '').toLowerCase()
    if (target && target !== '_self') {
      return
    }

    if (anchor.hasAttribute('download')) {
      return
    }

    let url
    try {
      url = new URL(href, window.location.origin)
    } catch (error) {
      return
    }

    if (url.origin !== window.location.origin) {
      return
    }

    const to = url.pathname + url.search + url.hash
    const current = window.location.pathname + window.location.search + window.location.hash

    if (to === current) {
      return
    }

    event.preventDefault()
    router.push(to).catch(() => {})
  })
}

const app = createApp(App)

// Make services available globally
app.config.globalProperties.$auth = AuthenticationService
app.config.globalProperties.$api = ApiService
app.config.globalProperties.$userService = UserService
app.config.globalProperties.$commonService = CommonService

// Global error handler
app.config.errorHandler = (error) => {
  console.error('Global error:', error)
}

// Global warning handler
app.config.warnHandler = (msg) => {
  console.warn('Global warning:', msg)
}

// Check authentication status on app start
AuthenticationService.checkAndRefreshToken().then(() => {
  store.dispatch('auth/checkAuthStatus')
}).catch((error) => {
  console.warn('Token check failed:', error)
})

app.use(store).use(router).mount('#app')

installSpaLinkNavigation()
